ScoreTrekBattle.Tournament.Group = (function() {
    var _this, CONFIG, STATUS;

    CONFIG = {
        DURATION: 1000,
        Z_INDEX: 999999
    };

    STATUS = {};

    function resetStatus() {
        STATUS = {
            $view: null,
            isMoving: false,
            dragging: false,
            tournamentPreset: {},
            groupCount: 0,
            groupSize: 0,
            participants: {}
        };
    }
    resetStatus();

    function render(teams) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.renderMulti([
                'tournament/group/group',
                'tournament/group/participants',
                'tournament/group/participant',
                'tournament/group/team',
                'tournament/group/player',
                'tournament/team/bye'
            ]).then(templates => {
                STATUS.$view = templates['tournament/group/group'].$view;

                renderGroupsTitle();

                // TODO check if team size works here
                renderTeams(
                    teams,
                    STATUS.tournamentPreset.teamSize || 1,
                    STATUS.$view.find('[data-id="teams"]'),
                    templates['tournament/group/team'].$view,
                    templates['tournament/group/player'].$view,
                    templates['tournament/team/bye'].$view
                );

                renderGroups(templates['tournament/group/participants'].$view, templates['tournament/group/participant'].$view);

                enableDragDrop();

                enableClickSelect();

                resolve();
            });
        });
    }

    function renderGroupsTitle() {
        var key;

        key = STATUS.tournamentPreset.preset.groupCount ? 'player/groups' : `player/koSystem/${STATUS.tournamentPreset.preset.koSystem}`;

        STATUS.$view.find('[data-id="groupsTitle"]').html(__i18n(key));
    }

    function renderTeams(teams, teamSize, $teams, $teamTemplate, $playerTemplate, $byeTemplate) {
        teams.forEach(team => {
            let $team;

            $team = renderTeam(team, teamSize, $teamTemplate, $playerTemplate, $byeTemplate);

            $teams.append($team);
        });

        $teams.attr({
            'data-group-count': STATUS.groupCount,
            'data-group-size': STATUS.groupSize,
            'style':  `--group-count: ${STATUS.groupCount}; --group-size: ${STATUS.groupSize}`
        });
    }

    function renderTeam(team, teamSize, $teamTemplate, $playerTemplate, $byeTemplate) {
        let $team, $teamPlayers, isTeam, isBye;
        
        isBye = !team;
        isTeam = (teamSize > 1);

        $team = $teamTemplate.clone();


        $team.toggleClass('isBye', isBye).attr({
            'data-team-id': isBye ? '__BYE__' : team.id,
            'data-players-count': teamSize,
            'data-is-team': isTeam ? 'yes' : 'no'
        }).find('[data-id="teamName"]').text(isBye ? __i18n('player/bye') : team.name);

        $teamPlayers = $team.find('[data-id="players"]');
        
        if (team) {
            team.participants.forEach(participantItem => {
                var participant, $player, participantSource;

                if (participantItem) {
                    participant = participantItem.id ? participantItem : STATUS.participants[participantItem];
                    $player = $playerTemplate.clone()
                    $player.attr('data-participant-id', participant.id);
                    $player.toggleClass('isProPlayer', !!participant.player.pro_account);
                    $player.find('[data-id="name"]').html(`${participant.player.name ? __escapeHTML(participant.player.name) : __i18n('player/deleted')}`);
                    $player.find('[data-id="avatar"]').css('background-image', `url(${participant.player.thumbnail})`);

                    participantSource = getParticipantSource(participant);

                    if (participantSource) {
                        $player.find('[data-id="playerFrom"]').css('display', '').text(participantSource);
                    }
                } else {
                    $player = renderBye($byeTemplate, isTeam);
                }

                $teamPlayers.append($player);
            });
        }

        while($teamPlayers.children().length < teamSize) {
            $teamPlayers.append(renderBye($byeTemplate, isTeam));
        }

        return $team;
    }

    function getParticipantSource(participant) {
        let hasGroup;
        if (!participant.prevTournamentId || !participant.prevTournamentPosition) {
            return '';
        }

        hasGroup = (participant.prevTournamentGroupNumber > 0);

        return __i18n(hasGroup ? 'player/groupWinner': 'player/qualificantPosition', {group: __i18n('game/group', {group: participant.prevTournamentGroupNumber}), position: participant.prevTournamentPosition});
    }

    function renderBye($byeTemplate, isDouble) {
        let $player;

        $player = $byeTemplate.clone();
        $player.find('[data-id="name"]').text(isDouble ? __i18n('tournament/team/none') : __i18n('player/bye'));

        return $player;
    }

    function renderGroups($groupTemplate, $participantTemplate) {
        var $groups, $group;

        $groups = STATUS.$view.find('[data-id="groups"]');

        for (var groupIndex = 0; groupIndex < STATUS.groupCount; groupIndex++) {
            $group = $groupTemplate.clone();
            $group.find('[data-id="groupName"]').text(__i18n(`tournament/group/name/${(STATUS.groupCount === 1) ? 'single' : 'multi'}`, {groupNumber: (groupIndex + 1), groupSize: STATUS.groupSize}));
            $group.attr('data-group-number', (groupIndex+1));
            for (var participantIndex = 0; participantIndex < STATUS.groupSize; participantIndex++) {
                $group.find('[data-id="participants"]').append(
                    $participantTemplate.clone().attr({
                        'data-players-count': STATUS.tournamentPreset.teamSize,
                        'data-is-team': (STATUS.tournamentPreset.teamSize > 1) ? 'yes' : 'no'
                    })
                );
            }
            $groups.append($group);
        }

        $groups.attr({
            'data-group-count': STATUS.groupCount,
            'data-group-ize': STATUS.groupSize,
            'style':  `--group-count: ${STATUS.groupCount}; --group-size: ${STATUS.groupSize}`
        });
    }

    function enableClickSelect() {
        STATUS.$view.find('[data-id="participant"] > [data-id="bye"]').on('click', function() {
            let $teamSelection, $targetParticipant, items, itemMap;

            $teamSelection = $('<div>').addClass('group-editor-teams-selector');
            $targetParticipant = $(this).closest('[data-id="participant"]');

            items = [];
            itemMap = {};

            STATUS.$view.find('[data-id="teams"] > [data-id="team"]').each(function() {
                let teamId, $team, $teamClone, removeClasses;

                $team = $(this);
                $teamClone = $team.clone();

                teamId = $team.attr('data-team-id');

                removeClasses = [];
                Array.prototype.forEach.call($teamClone.get(0).classList, className => {
                    if (className.startsWith('ui-')) {
                        removeClasses.push(className);
                    }
                });

                $teamClone.removeClass(removeClasses.join(' '));

                itemMap[teamId] = $team;

                items.push({
                    value: teamId,
                    html: $teamClone
                });
            });

            if (items.length === 0) {
                chmDialog.info(__i18n('tournament/group/assign/done'), '', __i18n('button/gotIt'));
                return;
            }

            chmSelect({
                title: __i18n(
                    (STATUS.groupCount === 1) ? 'tournament/group/assignPosition/single' : 'tournament/group/assignPosition/multi',
                    {
                        group: ($targetParticipant.closest('[data-id="group"]').attr('data-group-number')),
                        position: ($targetParticipant.index()+1)
                    }
                ),

                items: items,
                isSearchable: true,
                onSelect: function(value) {
                    if (STATUS.isMoving) {
                        return;
                    }

                    STATUS.isMoving = true;

                    moveTeamToParticipant(itemMap[value], $targetParticipant).then(() => {
                        STATUS.isMoving = false;
                    });
                }
            });
        });
    }

    function enableDragDrop() {
        var $teams, $scrollable;

        $teams = STATUS.$view.find('[data-id="teams"]');
        $scrollable = STATUS.$view.find('[data-id="scrollable"]').on('scroll', function() {
            if (!STATUS.dragging) {
                updateRelativePosition($scrollable, $teams);
            }
        });

        STATUS.$view.find('[data-id="team"]').draggable({
            revert: 'invalid',
            start: function(event, ui) {
                var $this, offsetTop;

                STATUS.dragging = true;

                $this = $(this);
                this.classList.add('isDragged');
                STATUS.$view.find('[data-id="team"]').css('z-index', '');
                this.style.zIndex = CONFIG.Z_INDEX;

                STATUS.$view.find('[data-id="teams"], [data-id="groups"]').css('z-index', '');
                $this.closest('[data-id="teams"], [data-id="groups"]').css('z-index', CONFIG.Z_INDEX);

                offsetTop = ($this.offset().top - $scrollable.offset().top);
                $scrollable.attr({
                    'data-min-top': (1 - offsetTop - $scrollable.scrollTop()),
                    'data-max-top': ($scrollable.get(0).scrollHeight - $scrollable.scrollTop() - offsetTop - this.offsetHeight),
                    'data-scroll-top': $scrollable.scrollTop()
                });
            },
            drag: function(event, ui) {
                var minTop, maxTop, justifiedTop, initialScrollTop;

                minTop = parseInt($scrollable.attr('data-min-top'), 10);
                maxTop = parseInt($scrollable.attr('data-max-top'), 10);

                initialScrollTop = parseInt($scrollable.attr('data-scroll-top'), 10);
                justifiedTop = (ui.position.top - $scrollable.scrollTop() + initialScrollTop);

                ui.position.top = Math.max(minTop, Math.min(maxTop, justifiedTop));
            },
            stop: function(event, ui) {
                this.classList.remove('isDragged');
                this.style.zIndex = '';

                STATUS.dragging = false;

                updateRelativePosition($scrollable, $teams);
            }
        });

        STATUS.$view.find('[data-id="team"]').droppable({
            accept: '[data-id="team"]',
            over: function(event, ui) {
                if (this.classList.contains('isDropped')) {
                    this.classList.add($(this).closest('[data-id="participants"]').is(ui.draggable.closest('[data-id="participants"]')) ? 'allowDrop' : 'willRemove');
                }
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop', 'willRemove');
            },
            drop: function(event, ui) {
                var $draggable, $droppable, $draggableParent, $droppableParent;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop', 'willRemove');
                $draggable.attr('style', '');

                if (!this.classList.contains('isDropped')) {
                    return;
                }

                $droppable = $(this);

                $draggableParent = $draggable.closest('[data-id="participant"]');
                $droppableParent = $droppable.closest('[data-id="participant"]');

                if ($draggable.closest('[data-id="participants"]').is($droppable.closest('[data-id="participants"]'))) {
                    $draggableParent.append($droppable);
                    $droppableParent.append($draggable);
                } else {
                    $droppable.after($draggable);
                    STATUS.$view.find('[data-id="teams"]').append($droppable);
                    $droppable.removeClass('isDropped');
                }

                $draggable.attr('style', '').addClass('isDropped');

                updateHasParticipant();
            }
        });

        STATUS.$view.find('[data-id="participant"] > [data-id="bye"]').droppable({
            accept: '[data-id="team"]',
            over: function(event, ui) {
                this.classList.add('allowDrop');
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');
                $draggable.attr('style', '').addClass('isDropped');

                $(this).after($draggable);

                updateHasParticipant();
            }
        });

        STATUS.$view.find('[data-id="teamsWrapper"]').droppable({
            accept: '[data-id="team"]',
            over: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                if ($draggable.hasClass('isDropped')) {
                    this.classList.add('allowDrop');
                }
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');
                $draggable.attr('style', '').removeClass('isDropped');

                $(this).find('[data-id="teams"]').append($draggable);

                updateHasParticipant();
            }
        });
    }

    function updateHasParticipant() {
        STATUS.$view.find('[data-id="participant"] > [data-id="bye"]').each(function() {
            this.classList.toggle('hasParticipant', ($(this).closest('[data-id="participant"]').find('[data-id="team"]').length > 0));
        });
    }

    function updateRelativePosition($scrollable, $element) {
        var scrollable, element;
        scrollable = $scrollable.get(0);
        element = $element.get(0);
        if (element.offsetHeight < scrollable.offsetHeight) {
            element.style.marginTop = `${scrollable.scrollTop}px`;
        } else if (element.offsetHeight < (scrollable.offsetHeight + scrollable.scrollTop)) {
            element.style.marginTop = `${Math.min((Math.floor(element.parentNode.offsetHeight - element.offsetHeight) - 2), (scrollable.scrollTop - (element.offsetHeight - scrollable.offsetHeight)))}px`;
        } else {
            element.style.marginTop = '';
        }
    }

    function getGroups() {
        var groups;
        groups = [];
        STATUS.$view.find('[data-id="groups"] > [data-id="group"]').each(function() {
            var group;
            group = [];
            this.querySelectorAll('[data-id="participant"]').forEach(participant => {
                var team;
                team = participant.querySelector('[data-id="team"]');
                group.push(team ? team.dataset.teamId : null);
            });
            groups.push(group);
        });
        return groups;
    }

    function start() {
        return new Promise(function(resolve, reject) {
            let dialog;

            dialog = chmDialog({
                title: __i18n((STATUS.groupCount === 1) ? 'tournament/group/assign/single' : 'tournament/group/assign/multi'),
                content: STATUS.$view,
                large: true,
                isPersistant: true,
                buttons: [
                    {
                        label: __i18n('button/apply'),
                        primary: true,
                        action: function() {
                            if (STATUS.$view.find('[data-id="teams"]').children().length > 0) {
                                chmDialog.info(__i18n('error/TEAMS_NOT_ALL_ASSIGNED'), null, __i18n('button/gotIt'));
                                return false;
                            }
                            resolve(getGroups());
                        }
                    },
                    {
                        label: __i18n('button/cancel'),
                        action: function() {
                            ScoreTrekBattle.View.confirmDiscardChanges().then(() => {
                                dialog.close();
                                reject();
                            }).catch(ignore => {});

                            return false;
                        }
                    }
                ]
            });
        });
    }

    function shuffleGroups() {
        var $teams, $team, $group, groupCount, groupSize, groupIndex, participantIndex, bucket;
        
        if (!STATUS.$view || STATUS.isMoving) {
            return;
        }

        STATUS.isMoving = true;

        $teams = STATUS.$view.find('[data-id="teams"]');
        $team = STATUS.$view.find('[data-id="team"]');
        $group = STATUS.$view.find('[data-id="group"]');
        $participant = STATUS.$view.find('[data-id="participant"]');

        bucket = [];

        if ($teams.children().length === 0) {
            $team.each(function() {
                this.classList.remove('isDropped');
                $teams.append(this);
            });
        }

        updateHasParticipant();

        setTimeout(() => {
            let promises;

            $teams.find('[data-id="team"]').each(function() {
                var $this;
                $this = $(this);
                bucket.push({
                    $team: $this,
                    offset: $this.offset()
                });
            });

            groupCount = $group.length;
            groupSize = $group.first().find('[data-id="participant"]').length;

            groupIndex = 0;
            participantIndex = 0;
            promises = [];

            while (bucket.length > 0) {
                (() => {
                    var $targetGroup, $targetParticipant, bucketItem, offset;

                    bucketItem = bucket.splice(Math.floor(Math.random() * bucket.length), 1).shift();

                    $targetGroup = getSmallestGroup($group);

                    $targetParticipant = (groupCount === 1) ? getTargetParticipantOrdered($targetGroup, groupSize, participantIndex) : getTargetParticipant($targetGroup);

                    promises.push(moveTeamToParticipant(bucketItem.$team, $targetParticipant));

                    participantIndex++;
                })();
            }

            Promise.all(promises).then(() => {
                STATUS.isMoving = false;
            });
        }, 100);
    }

    function moveTeamToParticipant($team, $targetParticipant) {
        return new Promise(resolve => {
            let $bye, sourceOffset, targetOffset;

            sourceOffset = $team.offset();

            $bye = $targetParticipant.find('[data-id="bye"]');

            if (
                $bye.hasClass('hasParticipant')
                ||
                ($team.length === 0)
                ||
                ($team.closest('[data-id="teams"]').length === 0)
                ||
                ($targetParticipant.length === 0)
                ||
                ($targetParticipant.attr('data-id') !== 'participant')
            ) {
                console.warn('Participant collision!', $team, $targetParticipant);
                return resolve();
            }

            $targetParticipant.append($team)
            $bye.addClass('hasParticipant');
            
            $team.addClass('isDropped');

            targetOffset = $team.offset();

            $team.css({
                transition: `transform 0ms`,
                transform: `translate(${sourceOffset.left - targetOffset.left}px, ${sourceOffset.top - targetOffset.top}px)`,
                zIndex: CONFIG.Z_INDEX
            });

            setTimeout(() => {
                $team.css({
                    transition: `transform ${CONFIG.DURATION}ms`,
                    transform: 'translate(0px, 0px)'
                });

                setTimeout(() => {
                    $team.css({
                        transition: '',
                        transform: '',
                        zIndex: ''
                    });

                    resolve();
                }, CONFIG.DURATION + 100);
            }, 100);
        });
    }

    function getSmallestGroup($group) {
        var childrenCount, $targetGroup;

        $targetGroup = $group.first();
        childrenCount = $targetGroup.find('[data-id="bye"].hasParticipant').length;

        $group.each(function() {
            var $currentGroup, currentChildrenCount;

            $currentGroup = $(this);
            currentChildrenCount = $currentGroup.find('[data-id="bye"].hasParticipant').length;

            if (currentChildrenCount < childrenCount) {
                childrenCount = currentChildrenCount;
                $targetGroup = $currentGroup;
            }
        });

        return $targetGroup;
    }

    function getTargetParticipant($targetGroup) {
        return $targetGroup.find('[data-id="bye"]:not(.isTeamBye):not(.hasParticipant)').first().closest('[data-id="participant"]');
    }

    function getTargetParticipantOrdered($targetGroup, groupSize, participantIndex) {
        var $targetParticipant;

        $targetParticipant = getTargetParticipantByPosition($targetGroup, groupSize, participantIndex);

        while($targetParticipant.find('[data-id="team"]').length > 0) {
            participantIndex++;
            $targetParticipant = getTargetParticipantByPosition($targetGroup, groupSize, participantIndex);
        }

        return $targetParticipant;
    }

    function getTargetParticipantByPosition($targetGroup, groupSize, participantIndex) {
        return $targetGroup.find('[data-id="participant"]').eq(getGroupParticipantPosition(groupSize, participantIndex));
    }

    function getGroupParticipantPosition(groupSize, participantIndex) {
        return ScoreTrekBattle.CONFIG.group.distribution[String(groupSize)][participantIndex];
    }

    _this = {
        assignTeams: function(participants, tournamentPreset, teams) {
            return new Promise(function(resolve, reject) {
                resetStatus();

                if (!tournamentPreset || !tournamentPreset.preset) {
                    reject(__i18n('error/INVALID_INPUT'));
                    return;
                }

                STATUS.participants = {};
                participants.forEach(participant => {
                    STATUS.participants[participant.id] = participant;
                });

                if (tournamentPreset.preset.koSystem === 'all') {
                    resolve([null]);
                    return;
                }

                STATUS.tournamentPreset = tournamentPreset;
                STATUS.groupCount = tournamentPreset.preset.groupCount ? tournamentPreset.preset.groupCount : 1;
                STATUS.groupSize = (STATUS.groupCount === 1) ? Numbers.calculateNextBase2(tournamentPreset.preset.playerLimit) : Math.ceil(tournamentPreset.preset.playerLimit / STATUS.groupCount);

                render(teams).then(start).then(resolve).catch(reject).finally(resetStatus);
            });
        },
        renderTeams: function(teams, teamSize) {
            return new Promise(resolve => {
                ScoreTrekBattle.Template.renderMulti([
                    'tournament/group/team',
                    'tournament/group/player',
                    'tournament/team/bye'
                ]).then(templates => {
                    var $teams;

                    $teams = [];

                    teams.forEach(team => {
                        $teams.push(renderTeam(
                            team,
                            teamSize,
                            templates['tournament/group/team'].$view,
                            templates['tournament/group/player'].$view,
                            templates['tournament/team/bye'].$view
                        ));
                    });

                    resolve($teams);
                });
            });
        }
    };

    ScoreTrekBattle.Event.on('action.groups.shuffle', function() {
        shuffleGroups();
    });

    return _this;
})();